import React, { useRef } from 'react';
import { useMapEvents } from 'react-leaflet';

const MouseIndicator = () => {
    const mouseIndicatorRef = useRef(null);

    useMapEvents({
        mousemove: (e) => {
            const { lat, lng } = e.latlng;
            mouseIndicatorRef.current.innerHTML = `LatLng(${lat.toFixed(3)}, ${lng.toFixed(3)})`;
        }
    });

    return (
        <div ref={mouseIndicatorRef} className="mouse-indicator"></div>
    );
};

export default MouseIndicator;
